import { Routes } from '@angular/router';
import { NotFoundComponent } from './components/common/not-found/not-found.component';

import { AccountPageComponent } from './components/accounts/components/account-page/account-page.component';
import { AccountsComponent } from './components/accounts/accounts.component';

import { AuthService } from './core/services/auth.service';
import { inject } from '@angular/core';
import { AccountService } from './components/accounts/services/account.service';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'authentication',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        component: AccountsComponent,
        canActivate: [() => inject(AuthService).isAuthenticated()],
        providers: [AccountService],
        children: [
            {
                path: '',
                component: AccountPageComponent,
                // resolve: {
                //     products: listOfProductsResolver,
                // },
            },
            {
                path: 'create-contract',
                loadComponent: () =>
                    import(
                        './components/accounts/containers/create-contract-container/create-contract-container.component'
                    ).then((m) => m.CreateContractContainerComponent),
            },
            {
                path: 'contract-events/:id',
                loadComponent: () =>
                    import(
                        './components/accounts/containers/contract-event-container/contract-event-container.component'
                    ).then((c) => c.ContractEventContainerComponent),
            },
        ],
    },
    {
        path: 'authentication',
        loadChildren: () =>
            import('./components/authentication/authentication.routes'),
    },
    {
        path: 'profiles',
        loadChildren: () => import('./components/profiles/profiles.routes'),
    },
    {
        path: 'events',
        loadChildren: () => import('./components/events/events.routes'),
    },
    {
        path: 'transactions',
        loadChildren: () =>
            import('./components/transactions/transactions.routes'),
    },
     {
        path: 'ledgers',
        loadChildren: () =>
            import('./components/ledgers/ledgers.routes'),
    },
    {
        path: 'contracts',
        loadChildren: () => import('./components/contracts/contracts.routes'),
    },

    { path: '**', component: NotFoundComponent }, // This line will remain down from the whole pages component list
];
